/** @jsx jsx */
import { Badge } from "../Badge"
import { Highlighter } from "../Highlighter"
import { jsx, Text, Box } from "theme-ui"
import { Severity as SeverityType } from "../../types"
import * as styles from "./styles"

import React from "react"

interface SeverityProps {
  className?: string
  severity?: SeverityType
  searchWords?: string[]
}

export const Severity: React.FC<SeverityProps> = ({
  className,
  severity,
  searchWords,
}) => {
  return (
    severity && (
      <Box sx={styles.root} className={className}>
        <Badge sx={styles.badge}>{severity.name}</Badge>
        {severity && severity.description && (
          <Text variant="small" sx={styles.description}>
            <Highlighter
              searchWords={searchWords}
              textToHighlight={severity.description}
            />
          </Text>
        )}
      </Box>
    )
  )
}
